import React from "react";

const Footer = () => {
  const now = new Date();
  const currentYear = now.getFullYear();

  const privacyPolicyUrl = `${window.context?.forumUrl}/privacy`;
  const termsUrl = `${window.context?.forumUrl}/terms`;

  return (
    <footer
      className="absolute center"
      style={{
        width: "100%",
        bottom: "0px",
        zIndex: -1,
      }}
    >
      <p className="body-s text-black-tint-70 p4">
        &copy; Copyright {currentYear} Minerva Project, Inc. All rights reserved.{" "}
        <a
          href={privacyPolicyUrl}
          target="_blank"
          rel="noreferrer"
          className="text-black-tint-70 underline"
        >
          Privacy Policy
        </a>
        <span> | </span>
        <a
          href={termsUrl}
          target="_blank"
          rel="noreferrer"
          className="text-black-tint-70 underline"
        >
          Terms
        </a>
      </p>
    </footer>
  );
};

export { Footer };
